import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'src/app/interfaces/user';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { RestService } from 'src/app/services/rest/rest.service';

@Component({
  selector: 'app-zonas',
  templateUrl: './zonas.page.html',
  styleUrls: ['./zonas.page.scss'],
})
export class ZonasPage implements OnInit {
  users: User[];
  zonas = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  allUsers: User[] = [];

  constructor(private utils: UtilsService,
              private rest: RestService) { }

  ngOnInit() {
  }

  ionViewWillEnter() {
    this.getUsers();
  }

  async getUsers() {
    await this.utils.showLoading();
    const result: any = await this.rest.getCurrentCargas();
    if (result !== false) {
      const cargas = result.body.records;
      this.users = cargas.map(elem => elem.user);
      this.users = this.utils.removeDuplicatesArray(this.users);
      console.log(this.users);
      const resp: any = await this.rest.getUsers(1, 100);
      console.log(resp);
      if (resp && resp.body.records.length > 0) {
        this.allUsers = resp.body.records;
        this.allUsers = this.allUsers.filter((el) => el.role === 'repartidor');
      }
      // User.cargas will be empty if no cargas are assigned to him/her
      this.users = this.users.filter((el) => el.role === 'repartidor');
    } else {
      console.log('Error');
      this.utils.showToast('Error cargando usuarios', 'danger');
    }
    await this.utils.hideLoading();
  }

  async saveZonas() {
    await this.utils.showLoading();
    this.users.forEach(async user => {
      await this.rest.editUser(user);
    });
    this.utils.showToast('Guardado con exito');
    await this.utils.hideLoading();
  }

  hasCurrentCargas(user: User) {
    const index = this.users.map(elem => elem._id).indexOf(user._id);
    if (index === -1) {
      return false;
    } else {
      return true;
    }
  }
}
